// extracted by mini-css-extract-plugin
export var aboveInput = "_jf-0";
export var actionButton = "_jf-5";
export var actionButtonContainer = "_jf-1";
export var actionIcon = "_jf-6";
export var aiInfoContainer = "_jf-2";
export var attachmentWrapper = "_jf-7";
export var bold = "_jf-3";
export var checkIcon = "_jf-8";
export var clickingRecipientBar = "_jf-11";
export var commentThreadSwitch = "_jf-a";
export var draftImage = "_jf-b";
export var draftImageContainer = "_jf-c";
export var draftImages = "_jf-e";
export var editButton = "_jf-g";
export var editor = "_jf-f";
export var editorContainer = "_jf-y";
export var editorErrorTooltipWrapper = "_jf-9";
export var headerDivider = "_jf-h";
export var icon = "_jf-i";
export var info = "_jf-j";
export var internal = "_jf-n";
export var internalDivider = "_jf-k";
export var internalMessage = "_jf-l";
export var messageInputCard = "_jf-m";
export var messageInputForm = "_jf-o";
export var messageInputFormInternal = "_jf-p";
export var options = "_jf-q";
export var publicMessageCustomer = "_jf-s";
export var publicMessageMerchant = "_jf-r";
export var removeImageButton = "_jf-d";
export var replyButtons = "_jf-t";
export var showSignatureButton = "_jf-u";
export var spinner = "_jf-v";
export var verticalButtonDivider = "_jf-4";
export var visibilitySelector = "_jf-w";
export var warning = "_jf-x";
export var wrappingText = "_jf-z";
export var writingInternalNoteTopBorder = "_jf-10";